const FE_ADDRESS = "https://faangcv-6b5fd.web.app"
const BE_ADDRESS = "https://cloud-run-source-deploy-xpck45w73q-uw.a.run.app"
const VERSION = "260909055931"

const basic_tier = {
    name: "Basic",
    color: "orange",
    rate: 5.0,
};

const standard_tier = {
    name: "Standard",
    color: "blue",
    rate: 25.0,
};

const full_tier = {
    name: "Full",
    color: "purple",
    rate: 50.0,
};

const basic_tier_ai = {
    name: "Basic AI",
    color: "orange",
    //rate: 5.0,
};

const full_tier_ai = {
    name: "Full AI",
    color: "green",
    //rate: 50.0,
};

const targeted_tier_ai = {
    name: "Targeted AI",
    color: "blue",
    //rate: 100.0,
};

const TIER_MAP = new Map();
TIER_MAP.set(1, basic_tier)
TIER_MAP.set(5, standard_tier)
TIER_MAP.set(10, full_tier)
TIER_MAP.set(101, basic_tier_ai)
TIER_MAP.set(105, full_tier_ai)
TIER_MAP.set(110, targeted_tier_ai)

const ApiTypes = {
	PUBLIC: "pub",
	REVIEWER: "rec",
	USER: "api",
	ADMIN: "admin"
}

// this has to be last
export default {
    FE_ADDRESS: FE_ADDRESS,
    BE_ADDRESS: BE_ADDRESS,
    VERSION: VERSION,
    TIER_MAP: TIER_MAP,
    API_TYPES: ApiTypes,
}